import Api from "@/services/api";
import qs from "querystring";

export default {
  search(
    value,
    fields,
    filters = [],
    hiddenFilter = "",
    page = 1,
    sortBy = "nom_soc",
    sortDesc,
    activeCreditor = true
  ) {
    return Api().post(
      "/creditors/search",
      qs.stringify({
        search: value,
        fields: fields,
        filters: JSON.stringify(filters),
        hiddenFilter: hiddenFilter,
        page: page,
        sortBy: sortBy,
        sortDesc: sortDesc,
        active: activeCreditor,
      })
    );
  },
  purchaseOrder(data) {
    return Api().get("/purchase-order?" + data);
  },
  sendLogin(id) {
    return Api().get("/creditor/" + id + "/send-login");
  },
  no_relance(id) {
    return Api().get("/creditor/" + id + "/no-relance");
  },
  get(id) {
    return Api().get("/creditor/" + id);
  },
  checkDuplicateTva(id, tva) {
    if (!id) {
      id = "0";
    }
    return Api().get(
      "/creditor/" + id + "/checkTVA?tva=" + encodeURIComponent(tva)
    );
  },
  getStats(id) {
    return Api().get("/creditor/" + id + "?stats=true");
  },
  getStatsRange(id, start, end) {
    return Api().get(
      "/creditor/" + id + "?stats=true&start=" + start + "&end=" + end
    );
  },
  getExpired(id, total = false) {
    return Api().get(
      "/creditor/expired-warrants/" +
        id +
        "?total=" +
        (total ? "true" : "false")
    );
  },
  createNotebook(id, data) {
    return Api().post(
      "/creditor/notebook/" + id,
      qs.stringify({
        data: JSON.stringify(data),
      })
    );
  },
  post(creditorObject) {
    return Api().post(
      "/creditor",
      qs.stringify({
        object: JSON.stringify(creditorObject),
      })
    );
  },
  toggleAge(id) {
    return Api().post("/creditor/" + id + "/toggle-age");
  },
  addNote(noteObject) {
    return Api().post(
      "/creditor/" + noteObject.creditorID + "/note",
      qs.stringify({
        note: noteObject.note,
        negotiateurID: noteObject.negotiateurID,
      })
    );
  },
  editNote(noteObject) {
    return Api().post(
      "/creditor/" + noteObject.creditorID + "/note",
      qs.stringify({
        noteId: noteObject.noteID,
        note: noteObject.note,
        negotiateurID: noteObject.negotiateurID,
      })
    );
  },
  deleteNote(noteObject) {
    return Api().delete(
      "/creditor/" + noteObject.creditorID + "/note/" + noteObject.noteID
    );
  },
  getPurchaseOrderPreviewPDF(data) {
    return Api().post("/creditor/purchase-order", "data=" + encodeURIComponent(JSON.stringify(data)))
  },
  invoices(id) {
    return Api().get("/creditor/invoices/" + id);
  },
  warrants(id, offset = 0) {
    return Api().get("/creditor/warrants/" + id + "?offset=" + offset);
  },
  warrants_info(id) {
    return Api().get("/creditor/warrants-info/" + id);
  },
  warrants_migrate(id_source, id_target) {
    return Api().get("/creditor/warrants-migrate/" + id_source + "/" + id_target);
  },
  warrants_expire(historique_mandatID) {
    return Api().post("/creditor/warrants-expire/" + historique_mandatID);
  },
  warrants_delete(historique_mandatID) {
    return Api().post("/creditor/warrants-delete/" + historique_mandatID);
  },
  payments(id) {
    return Api().get("/creditor/payments/" + id);
  },
  send_purchase_order(data) {
    return Api().post(
      "/creditor/send-purchase-order",
      "data=" + encodeURIComponent(JSON.stringify(data))
    );
  },
  translateQuality(text) {
    return Api().get(
      "/creditors/translate-quality/" + encodeURIComponent(text)
    );
  },
};
